import { createSlice } from '@reduxjs/toolkit';
import { eventShareApi } from './eventShareApi';
import { EventShare } from './types';

const eventShareSlice = createSlice({
  name: 'eventShare',
  initialState: {} as Record<string, EventShare[]>,
  reducers: {},
  extraReducers: builder => {
    builder.addMatcher(
      eventShareApi.endpoints.getEventSharesByPhone.matchFulfilled,
      (state, action) => {
        const phoneNumber = action.meta.arg.originalArgs.phoneNumber;
        const actualNumber = phoneNumber.replace('tel://', '');

        state[actualNumber] = action.payload;
      },
    );
  },
});

export default eventShareSlice.reducer;
